import { Route, Switch } from "react-router-dom/cjs/react-router-dom.min"
import Home from "../components/Home"
import AnytimeCheckin from "../components/AnytimeCheckin"
import { RenewSubscriptionScreen } from "../components/payments/RenewSubscriptionScreen"
import FlowDetailsPage from "../components/myCheckins/FlowDetailsPage"
import MyCheckins from "../components/myCheckins/MyCheckins"
import TransitionToBigPicture from "../components/bigPicture/TransitionToBigPicture"
import Profile from "../components/Profile"
import { ResetPassword } from "../components/authentication/ResetPassword"
import { ForgotPassword } from "../components/authentication/ForgotPassword"
import { useContext, useEffect, useState } from "react"
import { CheckinType } from "../Constants"
import { getAuth } from "firebase/auth"
import { useAuthState } from "react-firebase-hooks/auth"
import { CurrentMetadataForUser } from "../context/CurrentMetadataForUser"
import { RenewSubscriptionFlow } from "../components/payments/RenewSubscriptionFlow"
import { AuthLandingPage } from "../components/authentication/AuthLandingPage"
import { PaymentsContainer } from "../components/payments/PaymentsContainer"
import { WeekReflection } from "../components/weekReflection/WeekReflection"
import { WeekReflectionContextProvider } from "../components/weekReflection/WeekReflectionContext"
import { SharedContent } from "../components/SharedContent"
import ExplorePricing from "../components/payments/ExplorePricing"
import { getDaysToTrialEnd } from "../helpers/CalendarHelper"

export const RoutesForOnboardedUser = ({ timeOfDay }) => {
    const auth = getAuth();
    const [user] = useAuthState(auth);
    const { isUserPaidSubscriber, remindersOn, onboardedDate, trialEnd } = useContext(CurrentMetadataForUser);

    const [flowType, setFlowType] = useState(CheckinType.EntryFlow);
    const updateFlowType = (flowType) => {
        setFlowType(flowType);
    };

    const [daysToTrialEnd, setDaysToTrialEnd] = useState(1); // default value

    useEffect(() => {
        if (trialEnd) {
            const daysLeft = getDaysToTrialEnd(trialEnd)
            setDaysToTrialEnd(daysLeft)
        }

    }, [trialEnd])

    return (
        <Switch>
            <Route exact path="/">
                <Home timeOfDay={timeOfDay} flowType={flowType} user={user} />
            </Route>
            <Route exact path="/pricing">
                <ExplorePricing timeOfDay={timeOfDay} />
            </Route>
            <Route path="/take-a-flow">
                {isUserPaidSubscriber ? (
                    <AnytimeCheckin
                        timeOfDay={timeOfDay}
                        flowType={flowType}
                        updateFlowType={updateFlowType}
                        user={user}
                    />
                )
                    :
                    <RenewSubscriptionFlow
                        timeOfDay={timeOfDay}
                        headingType="flow"
                    />
                }
            </Route>
            {
                // Allow in app checkout if:
                // 1) User is not a paid subscriber, 
                // 2) Or if they're in trial mode that is about to expire AND they haven't upgraded to a paid subscription
                (!isUserPaidSubscriber
                    || (isUserPaidSubscriber && daysToTrialEnd !== null
                        && daysToTrialEnd < 4 && daysToTrialEnd >= 0)) && (
                    <Route path="/renew-subscription">
                        <RenewSubscriptionScreen />
                    </Route>
                )
            }
            {!isUserPaidSubscriber &&
                <Route path="/get-subscription">
                    <AuthLandingPage>
                        <PaymentsContainer />
                    </AuthLandingPage>
                </Route>
            }
            <Route path="/flows/:id">
                <FlowDetailsPage timeOfDay={timeOfDay} />
            </Route>
            <Route path="/flows">
                <MyCheckins timeOfDay={timeOfDay}
                    user={user}
                    remindersOn={remindersOn}
                    onboardedDate={onboardedDate}
                />
            </Route>
            <Route path="/shared">
                <WeekReflectionContextProvider>
                    <SharedContent />
                </WeekReflectionContextProvider>
            </Route>
            <Route path="/week-reflection">
                <WeekReflectionContextProvider>
                    <WeekReflection isUserPaidSubscriber={isUserPaidSubscriber} />
                </WeekReflectionContextProvider>
            </Route>
            <Route path="/big-picture">
                {isUserPaidSubscriber ?
                    <TransitionToBigPicture timeOfDay={timeOfDay} user={user} />
                    :
                    <RenewSubscriptionFlow
                        timeOfDay={timeOfDay}
                        headingType="bigPicture"
                    />
                }
            </Route>
            <Route path="/profile">
                <Profile timeOfDay={timeOfDay} user={user} />
            </Route>
            <Route path="/reset-password">
                <ResetPassword />
            </Route>
            <Route path="/forgot-password">
                <ForgotPassword />
            </Route>
            <Route>
                <Home timeOfDay={timeOfDay} flowType={flowType} user={user} />
            </Route>
        </Switch>
    )
}